export type EditorDisplayState = 'EDITOR' | 'SYNCING' | 'PROCESSING_WITH_PROGRESS' | 'PROCESSING' | 'PLACEHOLDER'

export type EditorDisplayStateInputs = {
  isPostProcessingComplete: boolean
  isMinutesGenerationOngoing: boolean
  minutesGenerationProgress: number | null
  isSuperuser: boolean
  editorConstructed: boolean
  hasInitiallySynced: boolean
}

export function deriveEditorDisplayState(inputs: EditorDisplayStateInputs): EditorDisplayState {
  if (inputs.isPostProcessingComplete) {
    return inputs.editorConstructed && inputs.hasInitiallySynced ? 'EDITOR' : 'SYNCING'
  }
  if (inputs.isMinutesGenerationOngoing) {
    return inputs.isSuperuser && inputs.minutesGenerationProgress !== null ? 'PROCESSING_WITH_PROGRESS' : 'PROCESSING'
  }
  return 'PLACEHOLDER'
}
